import { Component,HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';


export interface Features{
  icon: string;
  title: string;
  desc: string;
  btnClass: string;
}

export interface Works{
  number: string;
  title: string;
  image: string;
  desc: string;
}

export interface Service {
  icon: string;
  title: string;
  desc: string;
}

export interface Blog {
  image: string;
  title: string;
  category: string;
  color: string;
  time: string;
}

@Component({
  standalone: false,
  selector: 'app-home-three',
  templateUrl: './home-three.component.html',
  styleUrl: './home-three.component.css'
})
export class HomeThreeComponent {
  //Services
  features: Features[] = [
    {
      icon: 'bulb-yellow-icon',
      title: 'Creative Design',
      desc: 'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo.',
      btnClass: 'button-golden-yellow'
    },
    {
      icon: 'diamond-pink-icon',
      title: 'Development',
      desc: 'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo.',
      btnClass: 'button-pink-edge'
    },
    {
      icon: 'magic-purple-icon',
      title: 'Implementation',
      desc: 'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo.',
      btnClass: 'button-blue'
    }
  ];

  //Portfolio
  portfolios: Works[] = [
    {
      number: '01',
      title: 'Kinetic Sandscapes',
      image: 'assets/images/portfolio/grid/13.jpg',
      desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sed purus nibh. Donec facilisis id quam quis tincidunt.'
    },
    {
      number: '02',
      title: 'Hopscotch Payments',
      image: 'assets/images/portfolio/grid/14.jpg',
      desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sed purus nibh. Donec facilisis id quam quis tincidunt.'
    },
    {
      number: '03',
      title: 'Brooklyn Brewery',
      image: 'assets/images/portfolio/grid/15.jpg',
      desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sed purus nibh. Donec facilisis id quam quis tincidunt.'
    }
  ];

  //Services
  services: Service[] = [
    {
      icon: 'bi-laptop purple-color',
      title: 'Responsive',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-exclude color-primary',
      title: 'Development',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-gear blue-color',
      title: 'Implementation',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-chat-dots-fill green-color',
      title: 'Live Support',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-layers-fill yellow-color',
      title: 'Pixel Perfect',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-trophy-fill brown-color',
      title: 'Award Winning',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    }
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // OWl Slider
  testimonialOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 2,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  testimonials = [
    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-4.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-5.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-6.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-1.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }
  ];

  //Blogs
  posts: Blog[] = [
    {
      image: 'assets/images/blogs/post-01.jpg',
      title: 'Kobe Steel plant that supplied plane components being checked',
      category: 'News',
      color: 'purple-color',
      time: '7 hours ago'
    },
    {
      image: 'assets/images/blogs/post-02.jpg',
      title: 'They say that a picture is worth a thousand words',
      category: 'Events',
      color: 'pink-color',
      time: 'Yesterday'
    },
    {
      image: 'assets/images/blogs/post-03.jpg',
      title: 'NewsBike | NY News Satire, Parody and Spoof News',
      category: 'Blog',
      color: 'blue-color',
      time: 'December 21, 2024'
    }
  ];
}
